import { Property } from '@/components/form/fields/select/SelectInput';

export enum BasicBetterBest {
  UNSET = '-',
  BASIC = 'Basic',
  BETTER = 'Better',
  BEST = 'Best'
}

export const useBasicBetterBestOptions = () => {
  const options: Property[] = [
    {
      id: BasicBetterBest.UNSET,
      name: '-'
    },
    {
      id: BasicBetterBest.BASIC,
      name: 'Basic'
    },
    {
      id: BasicBetterBest.BETTER,
      name: 'Better'
    },
    {
      id: BasicBetterBest.BEST,
      name: 'Best'
    }
  ];

  return options;
};
